import React from 'react';
import { Chat, Channel, MessageList, Window } from 'stream-chat-react';
import { useLivestreamChat } from '@feature/livestream/hooks/useLivestreamChat';
import 'stream-chat-react/dist/css/v2/index.css';
import './LivestreamChatOverlay.css';

interface Props {
  chatChannelId: string | null | undefined;
  visible?: boolean;
}

export function LivestreamChatOverlay({ chatChannelId, visible = true }: Props): React.ReactElement | null {
  const { chatClient, channel, isReady, isLoading } = useLivestreamChat(chatChannelId);

  if (!visible || !chatChannelId) {
    return null;
  }

  if (isLoading) {
    return (
      <div style={styles.container}>
        <div style={styles.loadingText}>Connecting to chat...</div>
      </div>
    );
  }

  if (!isReady || !chatClient || !channel) {
    return null;
  }

  return (
    <div style={styles.container} className="livestream-chat-overlay">
      <Chat client={chatClient}>
        <Channel channel={channel}>
          <Window>
            <div style={styles.chatWrapper}>
              <MessageList />
            </div>
          </Window>
        </Channel>
      </Chat>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '40%',
    maxHeight: '300px',
    pointerEvents: 'none',
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    paddingBottom: '20px',
  },
  chatWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
  },
  loadingText: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '14px',
    padding: '20px',
    textAlign: 'center',
  },
};
